/* unplugin-vue-components disabled */import script from "./DailySelectView.vue?vue&type=script&setup=true&lang=js"
export * from "./DailySelectView.vue?vue&type=script&setup=true&lang=js"

import "./DailySelectView.vue?vue&type=style&index=0&id=0490dfdc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0490dfdc"]])

export default __exports__